import Environment from '../environment/Environment';
import { ObjToQueryString } from '../helpers/Helpers';

import { IPlanningPayload } from '../interfaces/rolling-plan-planning.interface';
import { IPhasingPayload } from '../interfaces/rolling-plan-phasing.interface';
import { IEditAllPayload } from '../interfaces/rolling-plan-edit-all.interface';
import { getRequest, HandlerResponse, postFileUploadRequest, putRequest } from './api';
import { genearteNewToken } from './NewToken.api';

export const GetRollingPlanData = async (queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return getRequest(`${Environment.API}/rollingSalesPlan/getSalesPlanData${queryString}`)
    .then((resp: any) => HandlerResponse(resp));
};

export const UpdateRollingPlanData = async (payload: IPlanningPayload, queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return putRequest(`${Environment.API}/rollingSalesPlan/editSalesPlanData${queryString}`, payload)
    .then((resp: any) => resp.text());
};

export const GetPhasingData = async (queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return getRequest(`${Environment.API}/rollingplan/phasing/rollingPlan/PhasingGrid${queryString}`)
    .then((resp: any) => HandlerResponse(resp));
};

export const UpdatePhasingData = async (payload: IPhasingPayload[], queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return putRequest(`${Environment.API}/rollingplan/phasing/rollingPlan/PhasingGrid/save${queryString}`, payload)
    .then((resp: any) => resp.text());
};

export const CopyDataToPlan = async (copyType: string, queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return getRequest(`${Environment.API}/rollingSalesPlan/copyPlan/${copyType}${queryString}`)
    .then((resp: any) => HandlerResponse(resp));
};

export const FreezePlan = async (queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return getRequest(`${Environment.API}/rollingSalesPlan/freezePlan${queryString}`)
    .then((resp: any) => HandlerResponse(resp));
};

export const FreezePlanEditAll = async (queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return getRequest(`${Environment.API}/rollingSalesPlan/freezePlan${queryString}`)
    .then((resp: any) => HandlerResponse(resp));
};

export const GoalSeek = async (queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return getRequest(`${Environment.API}/rollingSalesPlan/goalSeek${queryString}`)
    .then((resp: any) => HandlerResponse(resp));
};

export const ImportTemplate = async (file, queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return postFileUploadRequest(`${Environment.API}/excel/upload${queryString}`, file)
    .then((resp: any) => HandlerResponse(resp));
};

export const GetEditAllData = async (queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return getRequest(`${Environment.API}/rollingplan/editall/displayEditAllScreen${queryString}`)
    .then((resp: any) => HandlerResponse(resp));
};

export const UpdateEditAllData = async (payload: IEditAllPayload, queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return putRequest(`${Environment.API}/rollingplan/editall/save${queryString}`, payload)
    .then((resp: any) => HandlerResponse(resp));
};

export const ImportTemplateEditAll = async (file, queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return postFileUploadRequest(`${Environment.API}/excel/editAll/uploadTemplateEditAll${queryString}`, file)
    .then((resp: any) => HandlerResponse(resp));
};
